import React from 'react';
import PropTypes from 'prop-types';
import { CartHeader } from './PageHeader.styles.jsx';

const PageHeader = ({ eyebrow, title, desc, showPartTwo = false, button }) => {
  return (
    <CartHeader>
      <div className="div">
        {eyebrow && <p className="eyebrowHeader">{eyebrow}</p>}
        <h2>{title}</h2>
        <p className="desc">{desc}</p>

        {showPartTwo && (
          <p className="partTwoNote">
            <span>Note</span>
            Courses marked with a Part 2 badge include a required in-person
            practical component in Nova Scotia.
          </p>
        )}
      </div>
      <div>{button && <div className="buttonContainer">{button}</div>}</div>
    </CartHeader>
  );
};
PageHeader.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  showPartTwo: PropTypes.bool,
  button: PropTypes.node,
};
export default PageHeader;
